module.exports = __webpack_public_path__ + "images/green-nature-4-805ceb90908b6fcfcbda3dd3ee7547e5.jpg";